module.exports = __webpack_public_path__ + "static/media/DGAASS.ec8c71ba.png";